import { getQuerySelector } from '@redux-requests/core';
import { createSelector } from 'reselect';
import { Group, StoreState } from 'types';
import { fetchGroups } from './actions';

export const getGroups = createSelector([getQuerySelector({ type: fetchGroups })], (state): Record<string, Group> => {
  if (state.data) {
    return state.data;
  }
  return {};
});

export const getGroupById = (groupId: string) =>
  createSelector([getGroups], (groups): Group | false => {
    return groups[groupId];
  });

/**
 * Reverse index of every grouped difference to its group. Built in one pass and memoized on the
 * groups query, so lookups on hot paths (the throttled on-scroll overlay draw) don't rescan every
 * group's differenceList.
 */
export const getGroupIdByDifferenceId = createSelector([getGroups], (groups): Record<string, string> => {
  const index: Record<string, string> = {};
  Object.keys(groups).forEach((groupId) => {
    groups[groupId].differenceList?.forEach((differenceId) => {
      index[differenceId] = groupId;
    });
  });
  return index;
});

/** Group id owning `differenceId`, or `differenceId` itself when it isn't grouped. */
export const getGroupOrDifferenceId = (state: StoreState, differenceId: string): string =>
  getGroupIdByDifferenceId(state)[differenceId] ?? differenceId;
